import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DcBadgeModule } from '@datachain/ui-sdk/components/app-badge';
import { DcButtonModule } from '@datachain/ui-sdk/components/app-button';
import { DcPageModule } from '@datachain/ui-sdk/components/app-page';
import { DcPanelModule } from '@datachain/ui-sdk/components/app-panel';
import { DcAvatarModule } from '@datachain/ui-sdk/components/avatar';
import { DcBreadcrumbModule } from '@datachain/ui-sdk/components/breadcrumb';
import { DcNavigateDirectiveModule } from '@datachain/ui-sdk/directives';
import { DcArrayPipeModule } from '@datachain/ui-sdk/pipes';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DxDataGridModule } from 'devextreme-angular';

import { MaterialModule } from '../ui/material.module';
import { UiModule } from '../ui/ui.module';
import { ConnectorActionPopupComponent } from './components/connector-action-popup/connector-action-popup.component';
import { ConnectorListComponent } from './components/connector-list/connector-list.component';
import { ConnectorAdapter } from './connector.adapter';
import {
	ConnectorEffects,
	ConnectorFeatureKey,
	connectorReducers,
	ConnectorSelector,
} from './store';

@NgModule({
	declarations: [ConnectorListComponent, ConnectorActionPopupComponent],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		UiModule,
		MaterialModule,
		StoreModule.forFeature(ConnectorFeatureKey, connectorReducers),
		EffectsModule.forFeature([ConnectorEffects]),
		DxDataGridModule,
		NgOptimizedImage,
		FormsModule,
		DcPageModule,
		DcPanelModule,
		DcArrayPipeModule,
		DcBadgeModule,
		DcAvatarModule,
		DcNavigateDirectiveModule,
		DcBreadcrumbModule,
		DcButtonModule,
	],
	providers: [ConnectorAdapter, ConnectorSelector],
})
export class ConnectorModule {
	public constructor(private readonly injector: Injector) {
		const connectorListCmpElement = createCustomElement(
			ConnectorListComponent,
			{
				injector,
			}
		);
		customElements.define('app-connector-list', connectorListCmpElement);
	}
}
